// to run this script: tap cmd-shift-1 on keyboard; enter `convert_playlists_to_sparkl`
if (!window.custom_scripts) window.custom_scripts = {}
window.custom_scripts.convert_playlists_to_sparkl = {
	input_required: true,

	processed_activity_data: [],
	case_payload: null,

	log: '',
	add_to_log: function(s) { this.log += `${s}\n` },

	fn: async function(input, btn_clicked) {
		this.log = ''

		let framework_record = vapp.case_tree_component.framework_record
		let case_json = framework_record.json
		// console.log(framework_record)

		// parse parameters from input
		// Sample input:
/*
// French 7
sheet: https://docs.google.com/spreadsheets/d/1gFi5E2SnsOIEjYQ_fk-HVJOthIQmiLTzFtAU-V930Dw/edit?pli=1&gid=1645604883#gid=1645604883

// process: 1

resave_sparkls: yes
*/
		try {
			let o = {}
			let lines = input.split(/\n/)
			for (let line of lines) {
				line = line.trim()
				// skip empty lines and comments
				if (empty(line)) continue
				if (line.search(/^\/\//) == 0) continue

				if (line.search(/^\s*(.*?)\s*:\s*(.*?)\s*$/) > -1) {
					o[RegExp.$1] = RegExp.$2
				} else {
					this.add_to_log(`***ERROR: couldn’t process input line: ${line}`)
					return this.log
				}
			}
			input = o

		} catch(e) {
			console.error(e)
			this.add_to_log(`***ERROR: couldn’t process input`)
			return this.log
		}
		console.log('input', input)
		
		////////////////////////////////
		// if btn_clicked is 'run', process the input
		let show_save = false
		if (btn_clicked == 'run') {
			this.processed_activity_data = []

			// if input.sheet is empty, use sample data
			let raw_data
			if (empty(input.sheet)) {
				raw_data = this.sample_data
			} else {
				// try to get already-fetched data
				if (empty(vapp.retrieved_raw_data)) vapp.retrieved_raw_data = {}
				raw_data = vapp.retrieved_raw_data[input.sheet]

				if (empty(raw_data)) {
					// fetch the raw_data from the google sheet
					raw_data = await this.fetch_sheet_as_csv(input.sheet)
				} else console.warn('already got data')
				// if we didn't get data, die
				if (empty(raw_data)) {
					this.add_to_log(`***ERROR: couldn’t retrieve data from sheet`)
					return this.log
				}

				// store fetched data so we don't have to re-fetch it again if we're testing
				vapp.retrieved_raw_data[input.sheet] = raw_data
			}

			// if input.process is empty, process all activities; otherwise parse the activities to process
			if (empty(input.process)) input.process = 'all'
			else {
				input.process = input.process.split(/\s*,\s*/)
			}

			// split data into rows
			let rows = window.CSV.parse(raw_data)
			console.warn('raw data', rows)

			// process each included activity
			let row_number = 0
			let activities_found = 0
			while (row_number < rows.length) {
				// try to process the next activity
				let ecs_result = await this.ecs_process(row_number, rows)

				row_number = ecs_result[0]
				let activity_data = ecs_result[1]

				//////////////////////////
				// if we didn't receive back activity_data, we got an error
				if (empty(activity_data)) {
					this.log += ecs_result[2]	// this will be the log_lines
					this.log = '***ERROR (see below)\n\n' + this.log
					return this.log
				}

				// allow for only processing certain activities...
				++activities_found
				if (input.process !== 'all') {
					// input process could be, e.g., ['1', 'SP.GK.U2.L1.A3'] or ['SP.GK.U2.L1']
					let doit = false
					for (let p of input.process) {
						if (!isNaN(p*1)) {
							if (activities_found == p*1) {
								doit = true
								break
							}
						} else {
							// it's a code; could be a subject ('SP' or 'FR'), course ('SP.GK'), unit, lesson, or activity
							if (activity_data.activity_code && activity_data.activity_code.includes(p)) {
								doit = true
								break
							}
						}
					}
					// if (input.process.includes(activities_found + '')) doit = true
					// if (input.process.includes(activity_data.activity_code)) doit = true
					if (!doit) {
						console.warn(`skip activity ${activities_found} (${activity_data.activity_code})`)
						continue
					}
				}

				// if we get to here we're processing this activity, so add its log_lines to the log
				this.log += ecs_result[2]	// this will be the log_lines

				console.warn('received', row_number, activity_data)

				//////////////////////////
				// based on the activity_code, look for the activity's proper parent lesson, and see if the activity already exists
				// the parent should be everything except the 'AXXX' at the end
				let parent_code = activity_data.activity_code.replace(/\.A.+/, '')
				if (parent_code == activity_data.activity_code) {
					this.add_to_log(`***ERROR: activity_code “${activity_data.activity_code}” is invalid (couldn’t get parent code)`);
					return this.log
				}
				let case_activity_parent = case_json.CFItems.find(x=>x.humanCodingScheme == parent_code)

				// if we can't find a parent, die
				if (empty(case_activity_parent)) {
					this.add_to_log('***ERROR: Couldn’t find activity_parent: ' + activity_data.activity_code)
					return this.log
				}
				// console.warn(object_copy(case_activity_parent))

				// now look for item
				let case_activity_item = case_json.CFItems.find(x=>x.humanCodingScheme == activity_data.activity_code)
				if (!empty(case_activity_item)) {
					this.add_to_log('Replace existing CFItem: ' + activity_data.activity_code)
				} else {
					this.add_to_log('Create new CFItem: ' + activity_data.activity_code)
				}
				this.add_to_log('Add to parent: ' + case_activity_parent.humanCodingScheme)

				///////////////////////////////
				// push this activity's data to processed_activity_data, then go on to the next row
				this.processed_activity_data.push({
					activity_data: activity_data,
					case_activity_parent: case_activity_parent,
					case_activity_item: case_activity_item,
				})
			}

			// if we get through the loop, there was no error, so show the save btn
			this.log = `--------------------\nPROCESSED ${this.processed_activity_data.length} ACTIVITY(s):\nclick a btn above to initiate save or re-run\n--------------------\n\n${this.log}`
			show_save = true

			// make sure case_payload is null
			this.case_payload = null

		////////////////////////////////
		// else btn_clicked is 'save', so if case_payload hasn't been set, 
		// save sparkl activities if necessary and formulate CF data to send
		} else if (empty(this.case_payload)) {
			this.case_payload = {
				update_document_date: 'yes',
				check_out_and_in: 'yes',
				lsdoc_identifier: framework_record.lsdoc_identifier,
				CFItems: [],			// we will add only the updated properties of CFItems
				CFAssociations: [],		// but we will add the entire CFAssociations
			}

			let sparkls_saved = 0

			// for each processed activity...
			for (let pa of this.processed_activity_data) {
				let msg = `Activity ${pa.activity_data.activity_code}:`

				// construct archive data for the activity
				let ad = this.ecs_construct_activity_archive(pa.activity_data)

				// update or create the CFItem for the activity
				let cfi = new CFItem(pa.case_activity_item)

				// fill in identifier, uri, and date for new items
				if (empty(cfi.identifier)) cfi.complete_data(case_json.CFDocument)
				cfi.fullStatement = pa.activity_data.title
				cfi.humanCodingScheme = pa.activity_data.activity_code
				cfi.language = 'en'
				cfi.CFItemType = 'Learning Resource'

				// fill in educationLevel
				let course = pa.activity_data.activity_code.replace(/^(SP|FR)\.(.*?)\..*/, '$2')
				if (course.includes('HS')) cfi.educationLevel = ['09', '10', '11', '12']
				else if (course == 'GPK') cfi.educationLevel = ['PK']
				else if (course == 'GK') cfi.educationLevel = ['KG']
				else cfi.educationLevel = ['0' + course[1]]	// 01,02,03,...08

				// extensions
				if (empty(cfi.extensions)) cfi.extensions = {}
				cfi.extensions.ocxType = 'Activity'
				cfi.extensions.learningResourceType = 'interactive'
				cfi.extensions.educationalUse = 'assignment'
				cfi.extensions.provider = 'Chicago Public Schools'
				cfi.extensions.deliverySystem = 'sparkl'
				cfi.extensions.isIframeable = true

				cfi.extensions.summary = pa.activity_data.amd.long_description

				// if we have a non-999 resourceURL in the existing CFItem and resave_sparkls isn't 'yes', don't resave the sparkl activity
				let existing_sparkl_activity_id = this.ecs_get_sparkl_activity_id(cfi.extensions.resourceURL)
				if (empty(existing_sparkl_activity_id) || existing_sparkl_activity_id == '999' || input.resave_sparkls == 'yes') {
					if (existing_sparkl_activity_id == 999) existing_sparkl_activity_id = null

					// Save the activity to Sparkl, receiving back the sparkl_url
					let sparkl_url = await this.ecs_save_sparkl_activity(JSON.stringify(ad), existing_sparkl_activity_id)
					if (empty(sparkl_url)) {
						// if we receive null, it didn't work
						this.add_to_log('***ERROR: Couldn’t save activity for: ' + pa.activity_data.activity_code)
						return this.log
					}

					// complete cfi.extensions
					cfi.extensions.resourceURL = sparkl_url

					let sparkl_activity_id = this.ecs_get_sparkl_activity_id(cfi.extensions.resourceURL)
					if (sparkl_activity_id == existing_sparkl_activity_id) {
						msg += `   sparkl UPDATED (${sparkl_activity_id})`
					} else {
						msg += `   sparkl CREATED (${sparkl_activity_id})`
					}
					++sparkls_saved

				// if we get to here we're not saving/resaving the sparkl
				} else {
					let sparkl_activity_id = this.ecs_get_sparkl_activity_id(cfi.extensions.resourceURL)
					msg += ` sparkl unchanged (${sparkl_activity_id})`
				}

				// see if the cfitem is new or has changed (have to run cfi.to_json() first)
				cfi = cfi.to_json()
				let changed = (empty(pa.case_activity_item))
				if (!changed) for (let key in cfi) {
					if (JSON.stringify(cfi[key]) != JSON.stringify(pa.case_activity_item[key])) {
						changed = true
						break
					}
				}

				// if changed, add the CFItem to the payload for save
				if (changed) {
					this.case_payload.CFItems.push(cfi)
					if (empty(pa.case_activity_item)) {
						msg += ` /   CFItem CREATED`
					} else {
						msg += ` /   CFItem UPDATED`
					}
				} else {
					msg += ` / CFItem unchanged`
				}

				// and if the item didn't exist before, place it under its parent
				// TODO: deal with moving items only if needed
				if (empty(pa.case_activity_item)) {
					// get highest sequence number
					let pnode = framework_record.cfo.cfitems[pa.case_activity_parent.identifier].tree_nodes[0]
					let seq = U.get_next_sequenceNumber(pnode, framework_record)

					// generate the isChildOf assoc
					let assoc = U.create_association(pa.case_activity_parent, cfi, seq, case_json.CFDocument, 'isChildOf')

					// add to payload
					this.case_payload.CFAssociations.push(assoc.to_json())

					msg += ` / CFAssociation CREATED`
				} else {
					msg += ` / CFAssociation unchanged`
				}

				this.add_to_log(msg)
			}

			let sparkls_saved_msg = `${sparkls_saved} Sparkl activity(s) saved or updated`

			// if there's anything to save, say so and keep the save btn showing
			if (this.case_payload.CFItems.length > 0 || this.case_payload.CFAssociations.length > 0) {
				this.log = `--------------------\n${sparkls_saved_msg}\n\nREADY TO SAVE ${this.case_payload.CFItems.length} CFItem(s) and ${this.case_payload.CFItems.length} CFAssociation(s):\nclick a btn above to execute save, or update spreadsheet and re-run\n--------------------\n\n${this.log}`
				show_save = true
				console.warn('payload', this.case_payload)

			} else {
				// else reset case_payload and hide the save btn
				this.log = `--------------------\n${sparkls_saved_msg}\n\nNO CFItems OR CFAssociations NEED TO BE UPDATED:\nupdate spreadsheet and click btn above to re-run\n--------------------\n\n${this.log}`
				this.case_payload = null
				show_save = false
			}

		////////////////////////////////
		// if we get to here, btn_clicked is 'save' and we have the case_payload, so save
		} else {
			vapp.$store.dispatch('save_framework_data', this.case_payload).then(()=>{
				vapp.$alert('Reload to see updated framework data').then(x=>{
					vapp.reload_window()
				})
			})
		}

		return [this.log, show_save]
	},

	async fetch_sheet_as_csv(sheet_url) {
		// h/t Gemini
		let base_url = sheet_url.split('/edit')[0]
		let url_params = new URLSearchParams(new URL(sheet_url).hash.replace('#', '?'))
		let gid = url_params.get('gid') || '0'
		
		let export_url = `${base_url}/export?format=csv&gid=${gid}`
		
		try {
			U.loading_start()
			let response = await fetch(export_url)
			U.loading_stop()
			if (!response.ok) {
				console.error(`Failed to fetch sheet (1): ${response.statusText}`)
				return null
			}
			return await response.text()
		} catch(e) {
			U.loading_stop()
			vapp.$alert('Failed to fetch sheet (see console): ' + e)
			console.warn(e)
			return null
		}
	},

	async ecs_process(row_number, rows) {
		let verbose = false
		let log_lines = ''

		let inform = (msg, fn = 'log') => {
			// if (!verbose && fn == 'log') return
			msg = `Line ${row_number+1}: ${msg}`
			if (fn == 'error') {
				msg = `***ERROR: ${msg} ***`
				vapp.$inform(msg)
			} else if (fn == 'warn') {
				msg = `** ${msg} **`
			}

			// we add the lines to the log *after* we return, in case we're skipping this activity
			log_lines += `${msg}\n`
		}

		let activity_data = null

		while (true) {
			if (verbose) console.log('row_number', row_number)
			// when we've processed all rows, return
			if (row_number >= rows.length) {
				return [row_number, activity_data, log_lines]
			}

			row = rows[row_number]

			// trim all cells and skip empty lines
			let row_empty = true
			for (let i = 0; i < row.length; ++i) {
				row[i] = row[i].trim()
				if (!empty(row[i])) row_empty = false
			}
			if (row_empty) {
				if (verbose) inform('--')
				++row_number
				continue
			}

			// expand row into vars
			let [activity_code, raw_activity_name, exercise_title, interaction_type, url, exercise_teacher_notes, exercise_student_prompt, exercise_comments, playlist_description, playlist_teacher_prep, playlist_student_instructions] = row

			// skip lines with no url
			if (empty(url)) {
				// console.log('skip line with no url')
				++row_number
				continue
			}

			// if activity_code is 'Activity Code', assume it's headers
			if (activity_code.toLowerCase() == 'activity code') {
				inform('HEADERS')
				++row_number
				continue
			}

			// if first or second cell is 'comment', it's a comment
			if (activity_code.toLowerCase() == 'comment') {
				inform('COMMENT: ' + raw_activity_name)
				++row_number
				continue
			}
			if (raw_activity_name.toLowerCase() == 'comment') {
				inform('COMMENT: ' + exercise_title)
				++row_number
				continue
			}

			// on first row, initiate activity_data
			if (empty(activity_data)) {
				// cleanup on activity_name?
				let activity_name = raw_activity_name
				activity_name = activity_name.replace(/\s+!/g, '!')
				activity_name = activity_name.replace(/\s+\?/g, '?')

				// if we don't get an activity_code, try to make one from the title
				if (empty(activity_code)) {
					let m, xxx, subject, course, path, unit, lesson, activity
					// Elementary Spanish PreK 1.2.4 La familia
					// Elementary Spanish PreK 1.2 Mini-Lesson B- Los abuelos
					//  Elementary French PreK 1.2.1 J'ai 6 ans
					//  Elementary French PreK 1.2 Mini-Lesson II - Practice with Numbers
					if (!empty(m = raw_activity_name.match(/Elementary (Spanish|French) +(PreK) +(\d+)\.(\d+)\.(\d+) /i))) {
						[xxx, subject, course, unit, lesson, activity] = m
						course = `GPK`
					}
					else if (!empty(m = raw_activity_name.match(/Elementary (Spanish|French) +(PreK) +(\d+)\.(\d+)(?:[ -–]+)Mini-Lesson (\w+)/i))) {
						[xxx, subject, course, unit, lesson, activity] = m
						course = `GPK`
						activity = `M${activity}`
					}

					// Elementary Spanish K 2.1.4 La ropa y los colores
					// Elementary Spanish 4 4.1.1 Las mascotas
					// Elementary Spanish K 2.1 Mini-Lesson I-El mercado de ropa
					// Elementary Spanish 4 4.1 Mini-Lesson A-La tienda de mascotas
					//  Elementary French 3 3.1.1 Debout, il est sept heures !
					//  Elementary French 3 3.1 Mini-Lesson A - La pendule
					//  MS French 7 2.1.2 Je fais du sport.
					//  MS French 7 2.1 Mini-Lesson I - Propose des sports.
					else if (!empty(m = raw_activity_name.match(/(?:Elementary|MS) (Spanish|French) +(.*?) +(\d+)\.(\d+)\.(\d+) /i))) {
						[xxx, subject, course, unit, lesson, activity] = m
						course = `G${course}`
					}
					else if (!empty(m = raw_activity_name.match(/(?:Elementary|MS) (Spanish|French) +(.*?) +(\d+)\.(\d+)(?:[ -–]+)Mini-Lesson (\w+)/i))) {
						[xxx, subject, course, unit, lesson, activity] = m
						course = `G${course}`
						activity = `M${activity}`
					}

					//  Elementary French 3 0.1 Tut, tut ! Nous voilà.
					else if (!empty(m = raw_activity_name.match(/(?:Elementary|MS) (Spanish|French) +(.*?) +(\d+)\.(\d+) /i))) {
						[xxx, subject, course, unit, lesson] = m
						course = `G${course}`
						activity = '1'
					}

					// MS Spanish 6 A.1.2.2 Bienvenida, Marissa
					// MS Spanish 6 A.1.2 Mini-Lesson 2-Parejas famosas
					// MS Spanish 6 B.1.2.2 ¡Qué dolor!
					// MS Spanish 6 B.1.2 Mini-Lesson II-Los remedios caseros
					else if (!empty(m = raw_activity_name.match(/MS (Spanish) +(\d) +(A|B)\.(\d+)\.(\d+)\.(\d+) /i))) {
						[xxx, subject, course, path, unit, lesson, activity] = m
						course = `G${course}`
						unit = unit + path
					}
					else if (!empty(m = raw_activity_name.match(/MS (Spanish) +(\d) +(A|B)\.(\d+)\.(\d+)(?:[ -–]+)Mini-Lesson (\w+)/i))) {
						[xxx, subject, course, path, unit, lesson, activity] = m
						course = `G${course}`
						unit = unit + path
						activity = `M${activity}`
					}

					// HS Spanish 3 8.4.3 Historia, política y sociedad
					// HS Spanish 3 8.4 Mini-Lesson 4-¿Quién es quién?
					//  HS French II 4.2.1 Voir, croire, recevoir, apercevoir; Negative and affirmative expressions
					//  HS French II 4.2 Mini-Lesson B - Voir, croire, recevoir, apercevoir; Negative and affirmative expressions
					else if (!empty(m = raw_activity_name.match(/HS (Spanish|French) +(\w+) +(\w+)\.(\d+)\.(\d+) /i))) {
						[xxx, subject, course, unit, lesson, activity] = m
						if (!isNaN(course*1)) course = ['', 'I', 'II', 'III'][course*1]
						course = `HS${course}`
					}
					else if (!empty(m = raw_activity_name.match(/HS (Spanish|French) +(\w+) +(\w+)\.(\d+)(?:[ -–]+)Mini-Lesson (\w+)/i))) {
						[xxx, subject, course, unit, lesson, activity] = m
						if (!isNaN(course*1)) course = ['', 'I', 'II', 'III'][course*1]
						course = `HS${course}`
						activity = `M${activity}`
					}

					if (empty(m)) {
						this.add_to_log('')
						inform(`***ERROR: couldn’t get activity_code for activity “${raw_activity_name}”`)
						return [row_number, null, log_lines]
					}

					// use match components to make code...
					subject = (subject.toLowerCase() == 'spanish') ? 'SP' : 'FR'

					activity_code = `${subject}.${course}.U${unit}.L${lesson}.A${activity}`
				}

				log_lines += '\n'
				
				// we're going to process the row here, so update row_number
				inform(`NEW ACTIVITY: ${activity_code} / ${activity_name}`)

				// clean up teacher notes
				playlist_teacher_prep = playlist_teacher_prep.replace(/Teacher Facilitation Guide can be found here\.*/, '')
				
				//////////////////////////////////////////////////
				// initiate structure for a new activity
				activity_data = {
					activity_code: activity_code,
					raw_activity_name: raw_activity_name,

					title: activity_name,
					// save playlist_teacher_prep as activity teacher_notes and playlist_student_instructions as activity_instructions
					teacher_notes: this.ecs_format_text_content(playlist_teacher_prep),
					activity_instructions: this.ecs_format_text_content(playlist_student_instructions),

					amd: {
						// save playlist_description as long_description
						long_description: this.ecs_format_text_content(playlist_description),
						// these are settings for the video queries
						vq_iframe_always_open: "true",
						vq_auto_maximize: "true",
						vq_auto_maximize_starting_value: "true",
						vq_skip_part_completion: "true",
						vq_iframe_script: "vq_vista_correct",
						vq_min_time_to_spend: "0",
						case_activity_code: activity_code,
					},
					exercises: [],
				}
				//////////////////////////////////////////////////

			// else it's not the first row; if this is a new title, we're done with this activity
			// note that the raw_activity_name cell is allowed to be blank
			} else if (!empty(raw_activity_name) && raw_activity_name != activity_data.raw_activity_name) {
				// note that we don't increment the row_number here, so we'll process the row with the next activity
				return [row_number, activity_data, log_lines]
			}

			// if we don't have an exercise_title value, it means that this is a row that just initiates the activity, so...
			if (empty(exercise_title)) {
				++row_number
				continue
			}

			/////////////////////////////////////
			// process the exercise for this row

			// if we don't get an explicit interaction_type, try to guess based on the url
			if (empty(interaction_type)) {
				if (url.includes('google.com')) interaction_type = 'google slide'
				else if (url.includes('vhl')) interaction_type = 'vhl'
				else if (url.includes('vhl')) interaction_type = 'vhl'
			} else {
				interaction_type = interaction_type.toLowerCase()
			}

			// clean up exercise_title
			exercise_title = exercise_title.replace(/\s+!/g, '!')
			exercise_title = exercise_title.replace(/\s+\?/g, '?')

			let ex = {
				exercise_id: U.new_uuid(),
				exercise_title: exercise_title,
				exercise_comments: this.ecs_format_text_content(exercise_comments),
				disabled: false,
			}

			if (interaction_type == 'google slide') {
				// if this is a slide, transform the url to the form we need to show the slide in an iframe
				url = this.ecs_convert_google_slide_url(url)
				// if it's not a slide, it could be a document, which looks like it appears in the iframe OK...
				// console.warn('converted google url: ' + url)
			
			// "LTI Link (VHL)"
			} else if (interaction_type.includes('vhl')) {
				// the url should be the directory of the "activity"
				// this pattern will be converted to the right url in Video_Query.video_url()
				url = `CPS-VHL--${url}`
				// url = `/src/custom_interactions/cps-vista/${url}/index_alu.html`

			} else if (url.includes('google.com/file')) {
				// gemini says to change /view.* to preview; this should allow the file to be shown in an iframe properly
				url = url.replace(/\/view.*/, '/preview')

			// https://upload.wikimedia.org/wikipedia/commons/5/5c/Mi_pap%C3%A1_Andhy.JPG
			} else if (url.includes('upload.wikimedia.org')) {
				// these should work as-is

			} else {
				// if we can't figure out how to handle the file, disable the exercise
				ex.disabled = true
				console.warn(`unknown interaction_type (${activity_code}): ${url}`)
			}

			// currently we're only importing video queries; we can expand this later...
			let q = {
				uuid: U.new_uuid(),
				type: 'video',
				stars_available: 5,
				part_index: 0,
				prompt: this.ecs_format_text_content(exercise_student_prompt),
				video_source: 'interactive',
				video_id: url,
				show_in_iframe: true,
			}

			ex.exercise_type = 'freeform'
			ex.body = `<p>[[${q.uuid}]]</p>`
			if (!empty(exercise_teacher_notes)) {
				ex.teacher_notes = this.ecs_format_text_content(exercise_teacher_notes)
			}

			ex.queries = {}
			ex.queries[q.uuid] = q

			ex.parts = [{
				part_type: 'video',
				uuid: U.new_uuid(),
			}]

			let exr = ex

			///////////////////////////////////////
			// Add the exercise to activity_data
			activity_data.exercises.push(exr)

			inform(`EX: ${interaction_type} / ${exercise_title}`)

			++row_number
		}
	},

	// Normalizes any Google Slides URL format into an optimized Iframe Embed URL.
	// Supports standard share links, edit states, and "Publish to Web" links.
	ecs_convert_google_slide_url(url) {
		// Capture 1: The absolute base URL up to the action keyword (handles optional /e/)
		// Capture 2: The entire trailing parameter/hash payload
		let pattern = /^(https:\/\/docs\.google\.com\/presentation\/d\/(?:e\/)?[^\/\?#]+)\/(?:present|edit|pub)(.*)$/i;
		
		let match = url.match(pattern);
		if (!match) {
			// console.error('couldn’t convert google url: ' + url)
			return url
		}
		
		let [_, base_canvas, raw_arguments] = match;
		let normalized_arguments = '';

		if (raw_arguments) {
			// 1. Ensure the parameters initiate with a standard '?' instead of a '#' anchor
			// 2. Convert any internal '#' anchors into valid '&' query separators
			normalized_arguments = raw_arguments
			.replace(/^[?#]/, '?')
			.replace(/#/g, '&');
		}

		return `${base_canvas}/embed${normalized_arguments}`;
	},

	ecs_format_text_content(s) {
		if (empty(s)) return ''
		return s.trim()
		// return s.trim().replace(/\n/g, '<br>')
	},

	ecs_construct_activity_archive(ad) {
		// when generating archives "for real", we use a service (get_json_for_activity_archive), so that we know the format of exported archives
		// will match the format we need for importing archives.
		// Here, though, at present, we'll just create the archive here.
		// This should work fine for the present (5/2026) use case, where we're creating activities for CPS using Vista content.

		// start with the base activity data
		let o = {
			activity: {
				title: ad.title,
				editors: ',sparklcreationscript@commongoodlt.com,',
				exercises: [],
				stars_available: 0,
				teacher_notes: ad.teacher_notes,
				activity_instructions: ad.activity_instructions,

				case_resource_guid: ad.case_resource_guid,

				allow_retry: "yes",
				student_access_policy: "signed_in",
				amd: ad.amd,
				teacher_grading_required: false,
			},
			exercises: []
		}

		// now for each exercise...
		let exercise_number = 1
		for (let exr of ad.exercises) {
			// add to o.activity.exercises
			o.activity.exercises.push({
				exercise_id: exr.exercise_id,
				disabled: exr.disabled,
				number: exercise_number,
			})

			// the disabled flag only goes into activity.exercises, not the exercise DB record
			delete exr.disabled

			// add stars to o.activity.stars_available
			o.activity.stars_available += exr.stars_available

			// add to o.exercises
			// the archive format requires a list of query_guids for each exercise record
			exr.query_guids = []
			for (let uuid in exr.queries) {
				exr.query_guids.push(uuid)
				// TODO?: currently we're just passing the "raw" query data through; we *might* need to use the Sparkl query class...
				// exr.queries[uuid] = new Video_Query(exr.queries[uuid])
			}

			// TODO?: do we need to deal with original_activity_id? I think the service takes care of it

			// TODO?: currently we're just passing the "raw" data through; we *might* need to use the Sparkl Exercise_Record class...
			// let exr = new Exercise_Record(ex)
			o.exercises.push(exr)

			++exercise_number
		}

		return o
	},

	// modified from Sparkl ActivityArchives.vue
	async ecs_save_sparkl_activity(fileJSON, existing_sparkl_activity_id) {
		let sparkl_origin = 'https://sparkl-ed.com'

		// for debugging
		// return `${sparkl_origin}/999`

		// fileJSON should mimic the content of a Sparkl Archive file
		// send the fileJSON to the Satchel server, which will send it on to the Sparkl server to create the activity
		// the sparkl_url should be returned
		let payload = {
			clear_existing_exercises: 'yes',	// this clears out the original exercises
			json: fileJSON, 
			teacher_email: 'sparklcreationscript@commongoodlt.com', 

			sparkl_origin: sparkl_origin,
		}

		if (!empty(existing_sparkl_activity_id)) {
			payload.activity_id_to_replace = existing_sparkl_activity_id
		}

		U.loading_start()
		let ajax_result = await U.ajax_promise('create_sparkl_activity_from_archive', payload)
		U.loading_stop()
		if (ajax_result.status != 'ok') {
			// handle error: return null; caller will show an error and cancel what it is doing (ajax_promise will console.log the result)
			return null
		}

		// return activity url, which includes the sparkl_activity_id
		return `${sparkl_origin}/${ajax_result.sparkl_activity_id}`
	},

	ecs_get_sparkl_activity_id(url) {
		if (empty(url)) return null
		return url.replace(/^.*\/(\d\d+)$/, '$1')
	},

	sample_data: `
Activity Code,Activity Name,Exercise Title,Interaction Type,URL,Teacher Notes,Student Prompt,Comments,Playlist Description,Playlist Teacher Prep Notes,Playlist Student Instructions
SP.GK.U2.L1.A1,Elementary Spanish K 2.1.1 La ropa y los colores,Elementary Spanish K 2.1 La ropa y los colores,Google Slide,https://docs.google.com/presentation/d/1cI5iYxE5Uh_khaK6FkMvFZ4fi1NImaDyEFzw-aeW7yw/present?slide=id.g6074d3f457_0_0,"<p>Use this playlist for Day 1 of Unit 2 Lesson 1 - La ropa y los colores<br>
Proficiency level: Novice Low</p>Proficiency level: Novice Low","Welcome to Unit 2 Lesson 1 Day 1. We will introduce the places in Peru that Becky,
Kate, and their family will visit.
Bienvenidos al Día 1 de la Lección 1 de la Unidad 2. Presentaremos los sitios de Perú
que visitarán Becky, Kate y su familia.",This is an introduction to: Elementary Spanish Grade K - Unit 2 - Lesson 1 - Day 1,"In previous weeks the family traveled to Honduras, where they made new friends and visited several exciting places. The family is now visiting Peru, another Spanish-speaking country. They watch a parade and talk about clothes and colors.

Proficiency Level: Novice Low","Students will learn the names of colors and clothes. As a warm-up, place several blue, green, red, and yellow counters on your desk. Have volunteers identify the colors in English. Then invite students, one by one, to come to the front and choose a counter. Ask them to keep the counters on their desks for the playlist's activities. 

As you go through the objects in the playlist, you can click on the graduation cap to see the answer key for each activity.

Teacher Facilitation Guide can be found here.","Play each item in the playlist and follow the instructions to learn the names of some clothes and colors. 

Reproduce los elementos de la lista y sigue las instrucciones para aprender el nombre de algunas prendas de vestir y los colores."
SP.GK.U2.L1.A1,Elementary Spanish K 2.1.1 La ropa y los colores,Elementary Spanish K 2 Essential Question,Google Slide,https://docs.google.com/presentation/d/1oeTyVJjgurMKkqu36vdFI9m0pTZt-fqyj_3p5-_FXL8/present#slide=id.g5ee18f2284_0_0,"Explain to students that in the following days and weeks they will talk about the
people and places that are part of a community as they follow Kate, Becky, and their
parents on their visit to Peru. Tell them to pay attention to the places and people they
meet and try to connect them with the people and places they see every day in their
own community in Chicago.
At the end of this journey, they will be able to answer this question: How does being
part of a community help us? (¿Cómo nos ayuda ser parte de una comunidad?) Write
the question on the board, both in English and Spanish, and refer to it any time you
consider to be a good opportunity for students to answer it.","In the following weeks, you will follow Becky, Kate, and their parents on their journey to Peru. Listen to the question your teacher asks and think about it when you see and hear what the characters do.

En las próximas semanas, acompañarás a Becky, Kate y sus padres en su viaje por Perú. Escucha la pregunta que hará tu maestro y piensa en ella a medida que escuches y veas lo que hacen los personajes.",Activity to present the Essential Question of this unit: How does being part of a community help us? (¿Cómo nos ayuda ser parte de una comunidad?),"In previous weeks the family traveled to Honduras, where they made new friends and visited several exciting places. The family is now visiting Peru, another Spanish-speaking country. They watch a parade and talk about clothes and colors.

Proficiency Level: Novice Low","Students will learn the names of colors and clothes. As a warm-up, place several blue, green, red, and yellow counters on your desk. Have volunteers identify the colors in English. Then invite students, one by one, to come to the front and choose a counter. Ask them to keep the counters on their desks for the playlist's activities. 

As you go through the objects in the playlist, you can click on the graduation cap to see the answer key for each activity.

Teacher Facilitation Guide can be found here.","Play each item in the playlist and follow the instructions to learn the names of some clothes and colors. 

Reproduce los elementos de la lista y sigue las instrucciones para aprender el nombre de algunas prendas de vestir y los colores."
SP.GK.U2.L1.A1,Elementary Spanish K 2.1.1 La ropa y los colores,La ropa y los colores - Descubre Perú,LTI Link (VHL),771567_771567_cpsdeasbu2l1001,"Pueblo de Yanque:Point to the picture and explain that it shows the small town, or pueblo, of Yanque, in Peru. The town is having a celebration and people are wearing their typical attire. Becky, Kate, and their parents will visit the town of Yanque.
Ciudad de Arequipa: Point to the picture and tell students that it shows the main
square, or plaza, of the city of Arequipa. Explain that cities are very large towns. Cities
usually include buildings, houses, shopping centers, and parks.
Patio de la casa: Point to the picture and tell students that it shows a house's patio.
Explain that in Peru, houses often have patios, and that people enjoy being outdoors.
Plaza de la comunidad: Point to the picture and tell students that it shows
a plaza in Julio’s community. Explain that friends who live in the community like to
meet, talk, and spend time together in the plaza. A plaza may have fountains, benches,
and green areas.
Have students identify some of these places in their city, Chicago.","Look at these pictures of different places in Peru. Say what you see.
Mira las fotos de diferentes lugares de Perú. Di lo que ves.","This opener offers a preview of the unit's content and introduces the four places that the characters will visit in Peru: pueblo de Yanque, ciudad de Arequipa, the patio of a house, and a community square.","In previous weeks the family traveled to Honduras, where they made new friends and visited several exciting places. The family is now visiting Peru, another Spanish-speaking country. They watch a parade and talk about clothes and colors.

Proficiency Level: Novice Low","Students will learn the names of colors and clothes. As a warm-up, place several blue, green, red, and yellow counters on your desk. Have volunteers identify the colors in English. Then invite students, one by one, to come to the front and choose a counter. Ask them to keep the counters on their desks for the playlist's activities. 

As you go through the objects in the playlist, you can click on the graduation cap to see the answer key for each activity.

Teacher Facilitation Guide can be found here.","Play each item in the playlist and follow the instructions to learn the names of some clothes and colors. 

Reproduce los elementos de la lista y sigue las instrucciones para aprender el nombre de algunas prendas de vestir y los colores."
SP.GK.U2.L1.A1,Elementary Spanish K 2.1.1 La ropa y los colores,Elementary Spanish Photo Card: amarillo / verde / azul / rojo,Google Slide,https://docs.google.com/presentation/d/1CFGzNn_KWO_KuYu6v4K00JSG9XDgyKSt-drsz8hep0I/present#slide=id.g6074d3f457_0_0,"Frontload Vocabulary: Point to the colored squares one at a time and say the color
words in Spanish: amarillo (yellow), azul (blue), rojo (red), and verde (green). Have
students repeat after you. Distribute counters. Then point to the squares again. Say
the color in Spanish and ask students who have a counter of the same color to hold it
up as they say its color in Spanish.","Look at the colored squares. Say the colors in Spanish.
Mira los cuadrados de colores. Di los nombres de los colores en español.",Activity to name colors in Spanish.,"In previous weeks the family traveled to Honduras, where they made new friends and visited several exciting places. The family is now visiting Peru, another Spanish-speaking country. They watch a parade and talk about clothes and colors.

Proficiency Level: Novice Low","Students will learn the names of colors and clothes. As a warm-up, place several blue, green, red, and yellow counters on your desk. Have volunteers identify the colors in English. Then invite students, one by one, to come to the front and choose a counter. Ask them to keep the counters on their desks for the playlist's activities. 

As you go through the objects in the playlist, you can click on the graduation cap to see the answer key for each activity.

Teacher Facilitation Guide can be found here.","Play each item in the playlist and follow the instructions to learn the names of some clothes and colors. 

Reproduce los elementos de la lista y sigue las instrucciones para aprender el nombre de algunas prendas de vestir y los colores."
SP.GK.U2.L1.A1,Elementary Spanish K 2.1.1 La ropa y los colores,La ropa y los colores - La ropa y los colores,LTI Link (VHL),771568_771568_cpsdeasbu2l1002_,"Build Background: Direct students’ attention to the picture. Explain that the
photo shows a small town, or pueblo, in Peru. Tell students that it is common for
towns to have celebrations. During these celebrations, groups of people wear their
town’s traditional attire and dance traditional dances. Ask students if they have ever
seen a group of dancers in their city, Chicago, during a parade or similar event. Invite
volunteers to share descriptions of the dancers, such as the clothes they were wearing
and the color of their clothes.
Frontload Vocabulary: Read the dialogue to students as you point to each speech
bubble. Then have students repeat the dialogue together, after you. You may wish to
repeat this process two or three times.","Listen to the dialogue. Then repeat what each character says.
Escucha el diálogo. Luego, repite lo que dice cada personaje.","Becky, Kate, and their parents watch a parade in Yanque. They talk about their
favorite colors.","In previous weeks the family traveled to Honduras, where they made new friends and visited several exciting places. The family is now visiting Peru, another Spanish-speaking country. They watch a parade and talk about clothes and colors.

Proficiency Level: Novice Low","Students will learn the names of colors and clothes. As a warm-up, place several blue, green, red, and yellow counters on your desk. Have volunteers identify the colors in English. Then invite students, one by one, to come to the front and choose a counter. Ask them to keep the counters on their desks for the playlist's activities. 

As you go through the objects in the playlist, you can click on the graduation cap to see the answer key for each activity.

Teacher Facilitation Guide can be found here.","Play each item in the playlist and follow the instructions to learn the names of some clothes and colors. 

Reproduce los elementos de la lista y sigue las instrucciones para aprender el nombre de algunas prendas de vestir y los colores."
SP.GK.U2.L1.A1,Elementary Spanish K 2.1.1 La ropa y los colores,La ropa y los colores - Video : La ropa y los colores,LTI Link (VHL),776572_776572_cpsdeasbu2l1014,"Have students play the video and listen to what the family has to say about the parade
in Yanque.
Pause the video after each sentence and have students repeat. Ask students to point to
an object of the color mentioned in each sentence to ensure comprehension.
You may wish to turn captions on so that students can follow the dialogue.","Play the video. Listen to what each character says. Repeat each sentence.
Reproduce el video. Escucha lo que dice cada personaje. Repite las oraciones.","Video that shows Becky, Kate, and their parents watching a parade in Yanque.","In previous weeks the family traveled to Honduras, where they made new friends and visited several exciting places. The family is now visiting Peru, another Spanish-speaking country. They watch a parade and talk about clothes and colors.

Proficiency Level: Novice Low","Students will learn the names of colors and clothes. As a warm-up, place several blue, green, red, and yellow counters on your desk. Have volunteers identify the colors in English. Then invite students, one by one, to come to the front and choose a counter. Ask them to keep the counters on their desks for the playlist's activities. 

As you go through the objects in the playlist, you can click on the graduation cap to see the answer key for each activity.

Teacher Facilitation Guide can be found here.","Play each item in the playlist and follow the instructions to learn the names of some clothes and colors. 

Reproduce los elementos de la lista y sigue las instrucciones para aprender el nombre de algunas prendas de vestir y los colores."
SP.GK.U2.L1.A1,Elementary Spanish K 2.1.1 La ropa y los colores,La ropa y los colores - ¿Qué color te gusta?,LTI Link (VHL),771569_771569_cpsdeasbu2l1003_,"Language in Context: Have students look at the pictures. Explain that the
characters are wearing a poncho and that they will learn more about ponchos at the
end of the week.
Read the question and have students repeat it after you. Point to each character and
read what they say. Have students repeat each statement after you. Ask students if
they think Becky and Kate’s dad would like the color yellow. Role-play the dad saying
Me gusta el amarillo. (I like the color yellow.)
Invite volunteers to answer the question ¿Qué color te gusta? (What color do you
like?) Have them use the model Me gusta el... (I like the color ...).","Listen to what Kate, Becky, and their mom say. Repeat each sentence. Then, say
which color you like.
Escucha lo que dicen Kate, Becky y su mamá. Repite cada oración. Luego, di qué color te gusta.",Listening and speaking activity to express the color you like.,"In previous weeks the family traveled to Honduras, where they made new friends and visited several exciting places. The family is now visiting Peru, another Spanish-speaking country. They watch a parade and talk about clothes and colors.

Proficiency Level: Novice Low","Students will learn the names of colors and clothes. As a warm-up, place several blue, green, red, and yellow counters on your desk. Have volunteers identify the colors in English. Then invite students, one by one, to come to the front and choose a counter. Ask them to keep the counters on their desks for the playlist's activities. 

As you go through the objects in the playlist, you can click on the graduation cap to see the answer key for each activity.

Teacher Facilitation Guide can be found here.","Play each item in the playlist and follow the instructions to learn the names of some clothes and colors. 

Reproduce los elementos de la lista y sigue las instrucciones para aprender el nombre de algunas prendas de vestir y los colores."
SP.GK.U2.L1.A1,Elementary Spanish K 2.1.1 La ropa y los colores,La ropa y los colores - Video: ¿Qué color te gusta?,LTI Link (VHL),776571_776571_cpsdeasbu2l1013,"Have students play the video and listen to Kate, Becky, and their mother talking about
their favorite colors.
Pause the video after each statement and have students repeat.
You may wish to turn captions on so that students can follow the audio.
Invite volunteers to answer the question ¿Qué color te gusta? (What color do you
like?) Have them answer using the model Me gusta el... (I like the color ...).
Then, say: Raise your hands if you are wearing something azul. Stand up if you are
wearing something rojo. Clap your hands if you are wearing something amarillo.","Play the video and listen to what Kate, Becky, and their mom say. Repeat each
sentence. Say what color do you like.
Reproduce el video para escuchar lo que dicen Kate, Becky y su mamá. Repite cada oración. Di qué color te gusta.","Video that shows Kate, Becky, and their mother saying which colors they like.","In previous weeks the family traveled to Honduras, where they made new friends and visited several exciting places. The family is now visiting Peru, another Spanish-speaking country. They watch a parade and talk about clothes and colors.

Proficiency Level: Novice Low","Students will learn the names of colors and clothes. As a warm-up, place several blue, green, red, and yellow counters on your desk. Have volunteers identify the colors in English. Then invite students, one by one, to come to the front and choose a counter. Ask them to keep the counters on their desks for the playlist's activities. 

As you go through the objects in the playlist, you can click on the graduation cap to see the answer key for each activity.

Teacher Facilitation Guide can be found here.","Play each item in the playlist and follow the instructions to learn the names of some clothes and colors. 

Reproduce los elementos de la lista y sigue las instrucciones para aprender el nombre de algunas prendas de vestir y los colores."
SP.GK.U2.L1.A1,Elementary Spanish K 2.1.1 La ropa y los colores,Elementary Spanish K 2.1.1 Predecir,Google Slide,https://docs.google.com/presentation/d/1xsDKNinSLx1WB_HcU21qYtNNxM0nQIbIx4KZX8B0bSw/present#slide=id.g5ee18f2284_0_0,"Predict: Explain to students that tomorrow they will listen to a story. Have them look
at the illustrations. Ask them what they think the story might be about. Explain that by
telling what they think might happen in a story based on what they see in an
illustration they are making a prediction.
Draw a word web on the board and write los colores de la ropa in the main circle. You
might want to gesture to your clothing to indicate the meaning of ropa. Point to the
clothing in the pictures and ask students in Spanish what color different items are.
This might be an opportunity to expose them to the names of the clothing items ahead
of the next lesson through comprehensible input. Encourage students to answer using
the colors that they've just learned, as well as the characters’ names. Write the colors
they say in Spanish in different circles in a web around the main circle and do not
erase your word web until you confirm predictions after reading.","Look at the pictures. Say what you think the story might be about.
Mira las ilustraciones. Di de qué crees que trata la historia.",Preview of Unit 2 Lesson 1 Day 2 story,"In previous weeks the family traveled to Honduras, where they made new friends and visited several exciting places. The family is now visiting Peru, another Spanish-speaking country. They watch a parade and talk about clothes and colors.

Proficiency Level: Novice Low","Students will learn the names of colors and clothes. As a warm-up, place several blue, green, red, and yellow counters on your desk. Have volunteers identify the colors in English. Then invite students, one by one, to come to the front and choose a counter. Ask them to keep the counters on their desks for the playlist's activities. 

As you go through the objects in the playlist, you can click on the graduation cap to see the answer key for each activity.

Teacher Facilitation Guide can be found here.","Play each item in the playlist and follow the instructions to learn the names of some clothes and colors. 

Reproduce los elementos de la lista y sigue las instrucciones para aprender el nombre de algunas prendas de vestir y los colores."
`


}

